
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class InsConfirm extends Vue {
    public Title!:string;
    public Content!:string;
    public Visible:boolean = false;
    public Confirm!:Function;
    public Cancel!:Function;
    private LayerVisible:boolean = true;
    created () {
      // document.body.style.overflow = 'hidden';
    }
    doConfirm () {
      if (this.Confirm && this.Confirm instanceof Function) { this.Confirm(); };
      this.Visible = false;
      setTimeout(() => { this.LayerVisible = false; });
      // document.body.style.overflow = '';
    }
    doCacel () {
      if (this.Cancel && this.Cancel instanceof Function) { this.Cancel(); };
      this.Visible = false;
      setTimeout(() => { this.LayerVisible = false; });
    }
}
